export interface MitekHintsModel {
  [key: string]: string;
}
